(function () {
  'use strict';
  if (window.mzDyoOffer) return;
  window.mzDyoOffer = true;

  function track(spot) {
    var payload = { event: 'dyo_chat_click', dl_form_location: window.location.pathname, dl_chat_spot: spot || '' };
    if (window.dataLayer) window.dataLayer.push(payload);
  }

  // tidioChatApi is Tidio's supported way in, unlike clicking inside its iframe
  function openChat() {
    var api = window.tidioChatApi;
    if (!api || typeof api.open !== 'function') return false;
    if (typeof api.display === 'function') api.display(true);
    api.open();
    return true;
  }

  function goToForm(link) {
    var id = (link.getAttribute('href') || '').replace('#', '');
    var target = id && document.getElementById(id);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-mz-chat-open]');
    if (!link) return;
    e.preventDefault();
    track(link.getAttribute('data-mz-chat-spot'));
    if (openChat()) return;

    // the widget loads late; wait for it, then fall back to the enquiry form
    var done = false;
    function later() {
      if (done) return;
      done = true;
      if (!openChat()) goToForm(link);
    }
    document.addEventListener('tidioChat-ready', later, { once: true });
    setTimeout(later, 3000);
  });
})();
